import { Preset, Style } from "app/animate/[[...id]]/CreateAnimationTypes"

export type FilterableListItem = string | {
    name: string
    description?: string
    thumbnailUrls?: string[]
}


export type JobListFilter = {
    userId?: string,
    excludeJobIds?: string[],
    userNameFilter?: string,
    styleFilter?: string,
    presetFilter?: string,
    sourceFilter?: string,
    statusFilter?: string, // TODO: make array instead of comma delimited list that we split later.
    adminOverride?: boolean,
    featuredOnly?: boolean,
    publicOnly?: boolean,
    cursor?: string,
    skip?: number,
    take?: number,
    audioOnly?: boolean,
}

export type JobListFilterPageSearchParams = {
    userId?: string,
    excludeJobIds?: string,
    userNameFilter?: string,
    styleFilter?: string,
    presetFilter?: string,
    sourceFilter?: string,
    statusFilter?: string, // TODO: make array instead of comma delimited list that we split later.
    adminOverride?: string,
    featuredOnly?: string,
    publicOnly?: string,
    cursor?: string,
    skip?: string,
    take?: string,
    audioOnly?: string,
}


// TODO - improve polymorphism
export function getItemName(item : FilterableListItem) {
    return typeof item === 'string' ? item : item.name
}
export function getItemDescription(item : FilterableListItem) {
    return typeof item === 'string' ? undefined : item.description
}
export function getItemThumbnailUrls(item : FilterableListItem) {
    return typeof item === 'string' ? undefined : item.thumbnailUrls
}

export const styleOrPresetToFilterableListItem = (entry: Preset|Style) => ({
    name: entry.name,
    description: entry.description,
    thumbnailUrls: entry.thumbnailUrl ? [entry.thumbnailUrl] : undefined        
})


export function getJobListFilterFromPageSearchParams(searchParams: JobListFilterPageSearchParams) : JobListFilter {
    return {
        ...searchParams,
        excludeJobIds: searchParams.excludeJobIds?.split(','),
        adminOverride: searchParams.adminOverride?.toLowerCase() === 'true',
        featuredOnly: searchParams.featuredOnly?.toLowerCase() === 'true',
        publicOnly: searchParams.publicOnly?.toLowerCase() === 'true',
        audioOnly: searchParams.audioOnly?.toLowerCase() === 'true',
        skip: parseInt(searchParams.skip||"0"),
        take: parseInt(searchParams.take||"24"),
    }
}


export function getJobListFilterFromSearchParams(searchParams: URLSearchParams) : JobListFilter {
    return {
        userNameFilter: searchParams.get("userFilter")||undefined,
        styleFilter: searchParams.get("styleFilter")||undefined,
        presetFilter: searchParams.get("presetFilter")||undefined,
        sourceFilter: searchParams.get("sourceFilter")||undefined,
        statusFilter: searchParams.get("statusFilter")||undefined,
        adminOverride: searchParams.get("adminOverride") === 'true',
        featuredOnly: searchParams.get("featuredOnly") === 'true',
        publicOnly: searchParams.get("publicOnly") === 'true',
        audioOnly: searchParams.get("audioOnly") === 'true',
        cursor: searchParams.get("cursor")||undefined,
        skip: parseInt(searchParams.get("skip")||"0"),
        take: parseInt(searchParams.get("take")||"24"),
    }
}
